export default __webpack_public_path__ + "static/media/imageC1.6af8a4a7.png";